<template>
  <!-- NavBar Mobile -->
  <v-app-bar
    app
    flat
    height="80"
    class="dark-bg"
    v-if="isMobile"
  >
    <div class="ml-4 navbar-profile-img"></div>
    <v-spacer></v-spacer>
    <v-app-bar-nav-icon @click="drawer = !drawer"></v-app-bar-nav-icon>
  </v-app-bar>
  <!-- Drawer Mobile -->
  <v-navigation-drawer
    v-model="drawer"
    class="dark-bg"
    v-if="isMobile"
    temporary
  >
    <v-list>
      <v-list-item
        v-for="item in menuItens" 
        :key="item.id"
        @click="scrollToSection(item.id)"
        :class="{ activeSection: currentSection == item.id }"
      >
        <v-list-item-title>{{ item.text }}</v-list-item-title>
      </v-list-item>
    </v-list>

    <template v-slot:append>
      <LanguagePicker />
    </template>
  </v-navigation-drawer>

  <!-- Navbar Desktop -->
  <v-navigation-drawer
    v-if="!isMobile"
    class="dark-bg"
    permanent
  >
    <v-list>
      <v-list-item>
        <div class="navbar-profile-img"></div>
      </v-list-item>
      <v-divider></v-divider>
      <v-list-item
        v-for="item in menuItens" 
        :key="item.id"
        @click="scrollToSection(item.id)"
        :class="{ activeSection: currentSection == item.id }"
        class="ml-4 mt-2"
      >
        <v-list-item-title>{{ item.text }}</v-list-item-title>
      </v-list-item>
    </v-list>

    <template v-slot:append>
      <v-container>
        <LanguagePicker />
      </v-container>
    </template>
  </v-navigation-drawer>
</template>
<script>
import LanguagePicker from './LanguagePicker.vue';

/**
 * Barra de navegação (superior e lateral) da aplicação.
 */
export default {
  name: 'NavBar',
  components: {
    LanguagePicker
  },
  data() {
    return {
      drawer: false,
      windowWidth: window.innerWidth,
      currentSection: 'home'
    }
  },
  computed: {
    /**
     * Verifica o tamanho atual da tela do dispositivo para definir qual barra de navefação renderizar.
     */
    isMobile() {
      return this.windowWidth <= 960;
    },
    /**
     * Nomes e ID's das seções apresentadas no menu da aplicação.
     */
    menuItens() {
      return [
        { text: this.$t('NavBar.menu.home'), id: 'home' },
        { text: this.$t('NavBar.menu.projects'), id: 'projects' },
        { text: this.$t('NavBar.menu.about'), id: 'about' },
        { text: this.$t('NavBar.menu.services'), id: 'services' },
        { text: this.$t('NavBar.menu.contact'), id: 'contact' }
      ]
    }
  },
  mounted() {
    this.handleResize();
    window.addEventListener('resize', this.handleResize);

    const options = {
      root: null,
      rootMargin: "0px",
      threshold: 0.2
    };

    //Monta um observer para identificar em qual seção da aplicação está o usuário e destaca-la no meu de navegação.
    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          this.currentSection = entry.target.id;
        }
      });
    }, options);

    this.menuItens.forEach(item => {
      const section = document.getElementById(item.id);
      if (section) observer.observe(section);
    });
  },
  beforeUnmount() {
    window.removeEventListener('resize', this.handleResize);
  },
  methods: {
    /**
     * Garante a reatividade através o evento de resize
     */
    handleResize() {
      this.windowWidth = window.innerWidth;
    },
    /**
     * Move a tela do usuário até a seção selecionada no menu da barra de navegação.
     * 
     * @param id ID da section selecionada.
     */
    scrollToSection(id) {
      const section = document.getElementById(id);
      if (section) {
        section.scrollIntoView({ behavior: "smooth" });
        this.drawer = false;
      }
    }
  }
}
</script>

<style scoped>
.dark-bg {
  background-color: #070D1B;
  color: #afafaf;
}
.navbar-profile-img {
  height: 3rem;
  width: 3rem;
  border-radius: 50%;
  border: 1px solid #afafafad;
  background-image: url("@/assets/images/profile_1.webp");
  background-position: center;
  background-size: cover;
}
.activeSection {
  color: gold;
}

/**
 * Dispositivos médios/grandes
 * Vuetify 'md' Break Point
 */
@media (min-width: 960px) {
  .navbar-profile-img {
    height: 10rem;
    width: 10rem;
    margin-left: 2rem;
    margin-bottom: 2rem;
    margin-top: 2rem;
    border: 3px solid #afafafad;
  }
}
</style>
